import { render, staticRenderFns } from "./Webpush.vue?vue&type=template&id=3e906e88&scoped=true&"
import script from "./Webpush.js?vue&type=script&lang=js&"
export * from "./Webpush.js?vue&type=script&lang=js&"
import style0 from "./Webpush.scss?vue&type=style&index=0&id=3e906e88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e906e88",
  null
  
)

export default component.exports